import styled from 'styled-components'

// Override styles due to slick-carousel/react-slick.
export const DotContainer = styled.button`
    padding: 0 !important;
    &:before {
        opacity: 1;
        color: transparent !important;
    }
`
